<template>
	<div class="courseCollect ">
		<div class="" v-if="isFinish&&dataList.length>0">
			<div class="" style="height: 500px;">
				<div @click="goUrl(item,index)"
					class="cursor-pointer flex items-center justify-between p-[20px] box-border"
					v-for="(item,index) in dataList" :key="index">
					<div class="flex-1 flex items-center mr-[60px]">
						<el-image class="w-[120px] h-[80px] mr-[20px] rounded-[6px]" :src="item.info.cover_img"
							fit="cover"></el-image>
						<div class="flex-1 h-[77px] flex flex-col justify-between">
							<div class="text-[14px] text-[#545C63] yw-text-cut-2 ">
								{{item.info.name}}
							</div>
							<div class="text-[16px] font-bold text-[#FF0000]">
								￥{{item.info.course_discount}}
							</div>
						</div>
					</div>
					<div @click.stop="cancelCollect(item,index)"
						class="w-[91px] h-[34px] leading-[34px] cursor-pointer text-center text-white bg-[#FF0000] text-[14px] rounded-[4px]">
						{{langInfo.cancel_collect}}
					</div>
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>

		<emptyPage v-else-if="isFinish&&dataList.length==0" :title="langInfo.no_data_available">
		</emptyPage>
	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {

			emptyPage
		},
		data() {
			return {
				total: 0,
				page: 1,
				limit: 5,
				isFinish: false,
				dataList: [],
				langInfo: {},
			}
		},
		mounted() {
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title = this.langInfo.pc_name+'-'+this.langInfo.study_my_collect;
			}
			this.get_myCollection()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_collect;
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			goUrl(item, index) {
				this.$router.push({ path: '/courseDetail', query: { id: item.info.id } })
			},
			currentChange(e) {
				console.log(e);
				this.page = e
				this.get_myCollection()
			},
			get_myCollection() {
				// type=类型:1=资讯,2=资源,3=宝贝
				this.$api.myCollection({
					type: 3,
					page: this.page,
					limit: this.limit
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.dataList = res.data.list
					this.total = res.data.total
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			cancelCollect(item, index) {
				let that = this
				this.$confirm(this.langInfo.cancel_collect_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.news_resource_like({
						fid: item.info.id,
						type: 3, //1=资讯,2=资源,3=宝贝
						is_l: 2 //1=点赞,2=收藏
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'warning'
						})
						that.dataList.splice(index, 1)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}).catch(() => {
				
				});


			}

		}
	}
</script>

<style>
</style>